// extracted by mini-css-extract-plugin
export default {"wrapper":"Avatar_wrapper__LRzkG","label":"Avatar_label__NgsiR"};